import request from '@/utils/request'
import qs from 'qs'

const MOCK_URL: string = ''

// 搜索 - 列表
export const getSearchList = (data: any) =>
  request({
    url: `${MOCK_URL}/v2/app/search_list`,
    method: 'get',
    params: data
  })
// 获取搜索渠道映射
export const getSearchCategory = (data: { isIos: boolean }) =>
  request({
    url: `/app/search_map`,
    method: 'get',
    params: data
  })
// 修改权重
export const updateWeight = (data: IReqWeight) =>
  request({
    url: `/app/weight`,
    method: 'post',
    data: qs.stringify(data)
  })
// 添加搜索
export const addSearch = (data: Omit<IReqWeight, 'weight'>) =>
  request({
    url: `/app/weight/add`,
    method: 'post',
    data: qs.stringify(data)
  })
// 删除搜索
export const deleteSearch = (data: Omit<IReqWeight, 'weight'>) =>
  request({
    url: `/app/weight/delete`,
    method: 'post',
    data: qs.stringify(data)
  })
